import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { UserIcon, EngagingIcon, RetainingIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const features = [
  {
    heading: `Acquisition`,
    description: `Use first-party data to better target leads, optimize campaigns, and be more efficient with your ad spend.`,
    icon: <UserIcon />,
  },
  {
    heading: `Conversion`,
    description: `Easily design personalized, multi-channel communications to drive customers towards purchase with the right message at the right time.`,
    icon: <EngagingIcon />,
  },
  {
    heading: `Retention`,
    description: `Reactivate dormant customers and keep high-value customers engaged by consistently creating meaningful connections with them.`,
    icon: <RetainingIcon />,
  },
]

const copy = {
  heading: `Use cases`,
  description: `Drive efficient growth across the entire customer journey`,
}

export const UseCasesDriveGrowth = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <StyledSectionCopy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </StyledSectionCopy>
        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {features.map((feature, index) => (
              <StyledFeatureBoxBase key={index} alignment="left" headerPosition="top">
                <FeatureBox.Header>
                  <StyledIconWrapper variant="circle" background="light" elevation={1}>
                    {feature.icon}
                  </StyledIconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </StyledFeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;
`

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 844px;
`

const StyledIconWrapper = styled(IconWrapper)`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  max-width: 350px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: unset;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 0 15px;
  }

  ${({ theme }) => theme.breakpoints.up(`xxl`)} {
    padding: 24px 15px;
  }
`

export default UseCasesDriveGrowth
